import { Settings } from './settings.model';

export const RESOLVE_KEY = 'settingsData'; // key is the same as the RESOLVE in settings-data.resolve.ts

export interface ISettingsDataResolveData {
  settings: Settings;
}

export const MAX_POST_PURCHASE_SURVEY_COUNTER = 3;

// Backend schema only allows tax rate max 10
// @see
// eslint-disable-next-line max-len
// https://git.invoice2go.org/Cloud/underwood/blob/513dfd25d7f3149fc6ea186cf34f3c3f58d0d296/lib/schema/schemas/document/6.0.0/document-content-6.0.0.yaml#L184
export const TAX_RATE_LIMIT = 10;
